<template>
  <div
    class="bg-[#f4eaea] rounded-3xl shadow-[0_4px_24px_rgba(0,0,0,0.03)] flex flex-col items-center justify-center mb-6 p-10 md:p-20 mx-auto"
  >
    <h3 class="mb-4 text-[26px] md:text-[40px] text-[#222] text-center font-medium">
      {{ $t("accountRequest.title") }}
    </h3>
    <button
      class="min-w-[120px] bg-[#762123] border-none rounded-lg text-base font-medium px-9 py-2.5 cursor-pointer hover:bg-[#5a1819] transition-colors"
      style="color: #fff"
      @click="redirectToSignup"
    >
      {{ $t("button.signUp") }}
    </button>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

function redirectToSignup() {
  window.open(`/register/?language=${locale.value}`, "_self");
}
</script>
